import React, { FunctionComponent, memo } from 'react';
import Autocomplete, {
  AutocompleteRenderInputParams,
} from '@material-ui/lab/Autocomplete';
import { createFilterOptions } from '@material-ui/lab';
import { ComboBoxComponentProps } from './ComboBoxComponent.types';
import { TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  inputRoot: {
    color: theme.palette.primary.main,
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
    },
  },
}));

const renderInput = (
  params: AutocompleteRenderInputParams,
  variant: 'standard' | 'filled' | 'outlined',
  comboBoxName: string,
  placeholder: string
) => (
  <TextField
    {...params}
    variant={variant}
    label={comboBoxName}
    placeholder={placeholder}
  />
);

export const ComboBoxComponent: FunctionComponent<ComboBoxComponentProps> =
  memo(props => {
    const {
      className,
      comboBoxName,
      defaultValue = '',
      disabled = false,
      disableClearable = false,
      filterOptions,
      externalValuesHandler = false,
      id,
      comboBoxItems,
      multiple = false,
      onChange,
      placeholder,
      variant = 'outlined',
      value,
    } = props;
    let defValueSet;
    let filterOptionsConfig;
    if (multiple) {
      defValueSet = defaultValue ? [defaultValue] : [];
    } else {
      defValueSet = defaultValue ? defaultValue : null;
    }

    if (filterOptions) {
      filterOptionsConfig = createFilterOptions(filterOptions);
    }
    const classes = useStyles();
    const autocompleteParams = {
      classes,
      className,
      defaultValue: defValueSet,
      disableClearable: disableClearable,
      filterOptions: filterOptionsConfig,
      filterSelectedOptions: true,
      getOptionLabel: option => option.name,
      id,
      disabled,
      multiple,
      options: comboBoxItems,
      onChange: onChange as any,
      value,
      renderInput: params =>
        renderInput(params, variant, comboBoxName, placeholder),
    };
    const externalParams = externalValuesHandler && {
      value,
      getOptionSelected: (option, valueParam) =>
        option.value === valueParam.value,
    };

    return <Autocomplete {...autocompleteParams} {...externalParams} />;
  });

ComboBoxComponent.displayName = 'ComboBoxComponent';
ComboBoxComponent.whyDidYouRender = true;
